//
import { PropTypes } from 'prop-types';
import React from 'react';
import PreferenceCenterAPI from '../../api/preferencecenter/PreferenceCenterAPI';


class PreferenceCenterDatiPersonaliExport extends React.Component {
  constructor(props) {
    super(props);
  }

  handelExport =(event) =>{
    // "email,number,campo2"
    event.preventDefault();
    PreferenceCenterAPI.exportAnagrData(this.props.idOptin, this.props.hash, this.props.idList);
  }

  render() {
    const prefTexts = this.props.prefTexts;
    return(
      <div className="frontend-row frontend-text-center">
        <a onClick={this.handelExport} href="#">{prefTexts.personalData.downloadText}</a>
      </div>
    );
  }
}

PreferenceCenterDatiPersonaliExport.propTypes = {
  hash: PropTypes.string.isRequired,
  idOptin: PropTypes.number.isRequired,
  idList: PropTypes.number.isRequired,
  prefTexts: PropTypes.object.isRequired
};

export default PreferenceCenterDatiPersonaliExport;